module.exports = __webpack_public_path__ + "img/imgl.d6496a37.jpg";